import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FaceToStringPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'faceToString',
})
export class FaceToStringPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    let reg = new RegExp(/<img[\s\S]*?text="([^"]*)"[\s\S]*?>/, 'gim');

    // if(value.indexOf('qqemoji') > -1){
    //   return value.replace(reg, '$1').;
    // }
    // else
    return value
      .replace(reg, '$1')
      .replace(/<\/div>/g, '')
      .replace(/<div>/g, '\n');
  }
}



// WEBPACK FOOTER //
// ./src/pipes/face-to-string/face-to-string.ts